/* ==========================================================================
   Greasy Miniatures — loyalty popup, the half CSS cannot reach
   Vanilla JS, no dependencies, no build step.

   One job, and it is a plumbing job: the Bloy rewards panel renders its
   contents inside an <iframe>, and a stylesheet in this document does not
   cross into a child document. So this appends two links — the theme's
   tokens, then assets/greasy-bloy.css — to that frame's own <head>, which is
   the only way the rules in the second half of that file can ever match.

   It styles. It does not touch the programme: no balance is read, no rule is
   changed, no request is made to the app. If this file never runs, the panel
   is Bloy's stock white one and everything in it still works.

   WHY IT IS SAFE TO REACH IN
   The frame is written by the app as <iframe src=""> — that is about:blank,
   which inherits this page's origin, so contentDocument is reachable. If the
   app ever gives it a real cross-origin src, every access below throws, the
   catch swallows it, and the panel goes back to looking like stock Bloy.
   That is the intended failure, not a bug to fix.

   The two hrefs come from data attributes written by layout/theme.liquid,
   because an asset's real URL is a CDN path only Liquid knows.
   ========================================================================== */

(function () {
  'use strict';

  var self = document.currentScript;
  if (!self) return;

  var TOKENS = self.getAttribute('data-tokens');
  var SHEET = self.getAttribute('data-sheet');
  if (!TOKENS || !SHEET) return;

  /* Marks a frame document as already dressed. Also the thing the re-entry
     guard looks for, so a frame is never given two copies. */
  var MARK = 'gm-bloy-dressed';

  var CONTAINER = '#BLOY-popup-widget__container';

  function link(doc, href, id) {
    var el = doc.createElement('link');
    el.rel = 'stylesheet';
    el.href = href;
    if (id) el.id = id;
    doc.head.appendChild(el);
  }

  /* Appends the two stylesheets to one frame. Cheap and idempotent, so it
     can be called from every signal below without any coordination between
     them — which is the point, since none of them is reliable on its own. */
  function dress(frame) {
    var doc;
    try {
      doc = frame.contentDocument;
    } catch (e) {
      return; /* Cross-origin. Nothing to do, and nothing broken. */
    }
    if (!doc || !doc.head) return;
    if (doc.getElementById(MARK)) return;

    /* Tokens FIRST. greasy-bloy.css is written against --gm-* and the frame
       has never loaded the theme's stylesheets, so without this every value
       in it resolves to nothing and the rules quietly do half a job. */
    link(doc, TOKENS);
    link(doc, SHEET, MARK);
  }

  /* The frame's document is replaced when the app navigates it, and a
     replaced document has none of our links. Re-dressing on load costs
     nothing and covers that. */
  function watch(frame) {
    if (frame.getAttribute('data-gm-watched')) return;
    frame.setAttribute('data-gm-watched', '');
    frame.addEventListener('load', function () {
      dress(frame);
    });
    dress(frame);
  }

  function sweep() {
    var container = document.querySelector(CONTAINER);
    if (!container) return false;

    var frames = container.getElementsByTagName('iframe');
    for (var i = 0; i < frames.length; i++) watch(frames[i]);

    return true;
  }

  /* How long to keep looking for the app before concluding it is not on this
     page. It usually appears within two or three seconds; twenty is generous
     for a slow connection and still finite, which is the point — app embeds
     are per-theme and start DISABLED in a fresh theme, so "Bloy is not here
     at all" is a completely ordinary state and must not leave a document-wide
     observer running for the life of every page on the site. */
  var GIVE_UP_MS = 20000;

  /* The app's script is deferred and builds the container some seconds after
     this runs, so the container is normally absent at the first sweep. This
     watches the document for it to arrive — childList only, and disconnected
     the moment it finds it or the deadline passes — then narrows onto the
     container itself, which is a small box that changes rarely. */
  function observe() {
    if (typeof MutationObserver !== 'function') return;

    /* Declared before the observer that clears it. Mutations are delivered
       after this function has finished, so it is always assigned by then. */
    var deadline;

    var onContainer = new MutationObserver(function () {
      var container = document.querySelector(CONTAINER);
      if (!container) return;

      onContainer.disconnect();
      window.clearTimeout(deadline);
      sweep();

      /* The frame is created inside the container, and re-created if the
         panel is torn down and reopened. attributes:true catches
         data-open flipping, which is the app's own "the panel is being
         shown" signal and the moment a fresh frame is most likely. */
      new MutationObserver(sweep).observe(container, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-open']
      });
    });

    onContainer.observe(document.documentElement, { childList: true, subtree: true });

    deadline = window.setTimeout(function () {
      onContainer.disconnect();
    }, GIVE_UP_MS);
  }

  if (!sweep()) observe();

  /* Belt and braces for the case the observer misses: whatever else is true,
     the panel cannot be looked at without the launcher being pressed. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    if (!target.closest('.BLOY-widget') && !target.closest('[data-gm-rewards-open]')) return;
    window.setTimeout(sweep, 400);
    window.setTimeout(sweep, 1600);
  });
})();
